import { Context } from '@nuxt/types'
import { siteLoginUrl } from '~/assets/ts/utils/urls'

export default async function (context: Context) {
  const user = await context.$auth.user
  if (user) return
  context.$redirectTo(siteLoginUrl(context))
}
